import abilia from './abilia';
import detecht from './detecht';
import drumster from './drumster';
import easyEducation from './easy-education';
import installationspartner from './installationspartner';
// import medograf from './medograf';
import mevia from './mevia';
import polar from './polar';
import polarpumpen from './polarpumpen';
import mopz from './mopz';
import wrkat from './wrkat';
import yachtsafe from './yachtsafe';
import inspospotr from './inspospotr';

export default [
  drumster,
  detecht,
  installationspartner,
  easyEducation,
  wrkat,
  yachtsafe,
  // medograf,
  mopz,
  mevia,
  polarpumpen,
  inspospotr,
  polar,
  abilia,
];
